import {FC} from 'react'
import {useLang} from './Metronici18n'
import {IntlProvider} from 'react-intl'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/de'

import { WithChildren } from '../helpers'


const I18nProvider: FC<WithChildren> = ({children}) => {
  const locale = useLang()

  return (
    <IntlProvider locale={locale}>
      {children}
    </IntlProvider>
  )
}

export {I18nProvider}
